import { References } from "@abbvie-epi/common/models/references";
import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import gsap from "gsap";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { allReferences } from "./references.config";
@Component({
    selector: "app-references",
    templateUrl: "./references.component.html",
    styleUrls: ["./references.component.scss"]
})
export class ReferencesComponent implements OnInit {
    @Input() references: string[];

    public showDropdown: boolean = false;
    public allReferences: References = allReferences;

    @ViewChild("dropdown") dropdown: ElementRef;
    @ViewChild("dropdownContainer") dropdownContainer: ElementRef;

    constructor(private analyticsHelper: AnalyticsHelperService) {}

    ngOnInit(): void {}

    public toggleDropdown() {
        this.showDropdown = !this.showDropdown;
        const referencesHeight = this.dropdown.nativeElement.offsetHeight;

        if (this.showDropdown) {
            this.analyticsHelper.trackInteraction("global-references-accordion-expand");
            gsap.to(this.dropdownContainer.nativeElement, { height: referencesHeight, duration: 0.5 });
        } else {
            this.analyticsHelper.trackInteraction("global-references-accordion-close");
            gsap.to(this.dropdownContainer.nativeElement, { height: 0, duration: 0.5 });
        }
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }

    @HostListener("window:resize", ["$event"])
    onWindowResize() {
        if (this.showDropdown) {
            gsap.to(this.dropdownContainer.nativeElement, {
                height: this.dropdown.nativeElement.offsetHeight,
                duration: 0
            });
        }
    }
}
